module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    ref: "listContainer",
    staticClass: "list-container",
    style: ('visibility:' + _vm.visibility)
  }, [(_vm.customerName) ? _c('div', {
    staticStyle: {
      "margin": "0px 40px 10px 0px",
      "border": "solid green 1px",
      "padding": "5px 15px"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('name')) + ":"), _c('br'), _vm._v(_vm._s(' ' + _vm.customerName) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.itemList), function(item, index) {
    return _c('span', {
      staticClass: "orderItem"
    }, [(_vm.checkItemDisplay(item)) ? _c('li', [_c('div', {
      style: ('margin: 0px 40px 10px 0px;' + _vm.checkHeader(item))
    }, [(item.chk_cnt && item.chk_cnt > 1) ? _c('span', [_vm._v(_vm._s(item.chk_cnt) + " -")]) : _vm._e(), _vm._v(" "), (_vm.language == 'FR') ? _c('span', [_vm._v(_vm._s(item.name_2 || item.dtl_name))]) : _c('span', [_vm._v(_vm._s(item.dtl_name))]), _vm._v(" "), (item.items) ? _c('div', [_c('ul', {
      style: ('list-style-type: none; margin: 0px 20px 0px -25px;' + _vm.calcFontSize(item))
    }, _vm._l((item.items), function(subItem, index) {
      return _c('li', [(_vm.checkItemDisplay(subItem)) ? _c('div', [(_vm.language == 'FR') ? _c('span', [_vm._v(_vm._s(subItem.name_2 || subItem.dtl_name) + " "), (subItem.qty && subItem.qty > 1) ? _c('span', [_vm._v(" (x" + _vm._s(subItem.qty) + ")")]) : _vm._e()]) : _c('span', [_vm._v(_vm._s(subItem.dtl_name) + " "), (subItem.qty && subItem.qty > 1) ? _c('span', [_vm._v(" (x" + _vm._s(subItem.qty) + ")")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), (subItem.items) ? _c('div', [_c('ul', {
        staticStyle: {
          "list-style-type": "none",
          "margin-left": "-25px",
          "font-size": "small"
        }
      }, _vm._l((subItem.items), function(subsubItem) {
        return _c('li', [(_vm.checkItemDisplay(subsubItem)) ? _c('div', [(_vm.language == 'FR') ? _c('span', [_vm._v(_vm._s(subsubItem.name_2 || subsubItem.dtl_name))]) : _c('span', [_vm._v(_vm._s(subsubItem.dtl_name))]), _vm._v(" "), _c('br')]) : _vm._e()])
      }), 0)]) : _vm._e()]) : _vm._e()])
    }), 0)]) : _vm._e()])]) : _vm._e()])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66ff117f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderItems.vue
// module id = 531
// module chunks = 2